export enum USER_ROLE_CODE {
    NONE="none",
    CLIENT="Client",
    AGENT="Agent",
    ADMIN="Admin"

}